import React from 'react';
import MUIDialogActions from '@mui/material/DialogActions';
export const DialogActions = props => /*#__PURE__*/React.createElement(MUIDialogActions, props);
export default DialogActions;